import { AIMessage } from "@meta-press/shared-plugins";



export class Story {
  MarkCachePoint() {
    if (this.messages.length > 0) {
      const lastMessage = this.messages[this.messages.length - 1];
      lastMessage.cache = true;
    }
  }
  constructor(storyID: number) {
    this.storyID = storyID;
  }
  storyID = -1;
  messages: AIMessage[] = [];
  storage: Map<string, any> = new Map();
}
